$('.herobanner').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    //fade: true,
    speed: 800,
    dots:true,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    //infinite: true,
    //cssEase: 'ease-in-out',
  });

  $('.prod_slider__list').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    //fade: true,
    speed: 800,
    dots:true,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    //infinite: true,
    //cssEase: 'ease-in-out',
  });